/* import __COLOCATED_TEMPLATE__ from './seller-menu.hbs'; */
import Component from '@glimmer/component';
import constants from 'sh-www/constants';

class SellerSideMenuComponent extends Component {
  get constants() {
    return constants;
  }
}

export default SellerSideMenuComponent;
